import React, { useMemo, useState } from "react";

import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#dialog-selecionar-materiais-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function DialogSelecionarMateriais({
  open,
  onClose,
  materiaisCombo,
  carregarMateriaisCombo,
  materialLabel,
  onConfirmar,
}) {
  const [pesquisa, setPesquisa] = useState("");
  const [selecionados, setSelecionados] = useState([]);

  const materiaisFiltrados = useMemo(() => {
    const termos = pesquisa.toLowerCase().trim().split(/\s+/).filter(Boolean);

    return materiaisCombo
      .filter((m) => {
        const texto = `${m.ref || ""} ${m.nome || ""}`
          .toLowerCase()
          .replace(/,/g, ".")
          .replace(/\s+/g, "");

        return termos.every((t) => texto.includes(t.replace(/,/g, ".").replace(/\s+/g, "")));
      })
      .sort((a, b) => {
        const ia = Number(a.inativo || 0);
        const ib = Number(b.inativo || 0);

        if (ia !== ib) return ia - ib;

        return String(a.nome || "").localeCompare(String(b.nome || ""));
      });
  }, [materiaisCombo, pesquisa]);

  const toggleSelecionado = (ref) => {
    setSelecionados((p) => (p.includes(ref) ? p.filter((x) => x !== ref) : [...p, ref]));
  };

  const selecionarTodosVisiveis = () => {
    setSelecionados((p) => {
      const refs = materiaisFiltrados.map((m) => m.ref);
      return Array.from(new Set([...p, ...refs]));
    });
  };

  const confirmar = () => {
    const lista = materiaisCombo.filter((m) => selecionados.includes(m.ref));
    onConfirmar(lista);
    setSelecionados([]);
    setPesquisa("");
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth PaperComponent={PaperComponent}>
      <DialogTitle id="dialog-selecionar-materiais-title" style={{ cursor: "move" }}>
        Selecionar materiais
      </DialogTitle>

      <DialogContent>
        <MDBox display="flex" gap={1} mb={2} mt={1}>
          <TextField
            size="small"
            fullWidth
            label="Pesquisar materiais"
            value={pesquisa}
            onChange={(e) => {
              setPesquisa(e.target.value);
              carregarMateriaisCombo(e.target.value);
            }}
          />

          <MDButton color="info" onClick={selecionarTodosVisiveis}>
            Selecionar visíveis
          </MDButton>

          <MDButton color="secondary" onClick={() => setSelecionados([])}>
            Limpar
          </MDButton>
        </MDBox>

        <MDTypography variant="caption">Selecionados: {selecionados.length}</MDTypography>

        <MDBox sx={{ maxHeight: "60vh", overflow: "auto", mt: 1 }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ width: 40 }} />
                <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Ref.</th>
                <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Material</th>
                <th style={{ textAlign: "left", fontSize: 12, padding: 6 }}>Estado</th>
              </tr>
            </thead>

            <tbody>
              {materiaisFiltrados.map((m) => {
                const inativo = Number(m.inativo || 0) === 1;

                return (
                  <tr key={m.ref}>
                    <td style={{ borderTop: "1px solid #eee" }}>
                      <Checkbox
                        size="small"
                        checked={selecionados.includes(m.ref)}
                        onChange={() => toggleSelecionado(m.ref)}
                      />
                    </td>

                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {m.ref}
                    </td>

                    <td
                      style={{
                        fontSize: 12,
                        padding: 6,
                        borderTop: "1px solid #eee",
                        color: inativo ? "#d32f2f" : undefined,
                        fontWeight: inativo ? "bold" : undefined,
                      }}
                    >
                      {materialLabel(m)}
                    </td>

                    <td style={{ fontSize: 12, padding: 6, borderTop: "1px solid #eee" }}>
                      {inativo ? "Inativo" : "Ativo"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </MDBox>
      </DialogContent>

      <DialogActions>
        <MDButton color="secondary" onClick={onClose}>
          Cancelar
        </MDButton>

        <MDButton color="success" onClick={confirmar}>
          Adicionar selecionados
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
